import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from '@app/shell/loader/loader.component';
import { EnvironmentInfoComponent } from './shared/environment-info/environment-info.component';

@Component({
  selector: 'zero-waste-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent, EnvironmentInfoComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'zeroWastae';
}
